export enum NorthbeamUtmPlatform {
  AVANT_LINK = "AvantLink",
  CNN5_THINGS = "CNN5Things",
  KLAVIYO = "Klaviyo",
  META = "Meta",
  GOOGLE = "Google",
  SNAPCHAT = "Snapchat",
  RAKUTEN = "Rakuten",
  PINTEREST = "Pinterest",
  TABOOLA = "Taboola",
  OUTBRAIN = "Outbrain",
  STACK_ADAPT = "StackAdapt",
  SHARE_A_SALE = "ShareASale",
  PARTNERIZE = "Partnerize",
  REVCONTENT = "Revcontent",
  IMPACT_RADIUS = "ImpactRadius",
  TIKTOK = "TikTok",
  CRITEO = "Criteo",
  TWITTER = "Twitter",
  AD_ROLL = "AdRoll",
  GRIN = "Grin",
  YAHOO_DSP = "Yahoo DSP",
  RETENTION_SCIENCE = "Retention Science",
  LIVE_INTENT = "LiveIntent",
  POST_SCRIPT = "Postscript",
  MICROSOFT = "Microsoft",
  OTHER = "Other",
}
